import DiscoMoreActionsDropdown from "@disco-ui/dropdown/DiscoMoreActionsDropdown"
import { ReactElement } from "react"

interface UserCardAdminDropdownProps {
  content?: ReactElement
  testid?: string
}

function UserCardAdminDropdown({ content, testid }: UserCardAdminDropdownProps) {
  return (
    <DiscoMoreActionsDropdown testid={`${testid}.UserCardAdminDropdown`}>
      {content}
    </DiscoMoreActionsDropdown>
  )
}

export default UserCardAdminDropdown
